module.exports = __webpack_public_path__ + "img/ic_sq.6a75ed76.svg";